// set the token and user from the session storage
export const setUserSession = (token, user, pwd, decryptedKey, iv, salt, peerGroupId, regionID) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('password', pwd);
    localStorage.setItem('decryptedKey', decryptedKey);
    localStorage.setItem('iv', iv);
    localStorage.setItem('salt', salt);
    localStorage.setItem('peerGroupId', peerGroupId);
    localStorage.setItem('regionId', regionID);
}

// return the token from the session storage
export const getToken = () => {
    return localStorage.getItem('token') || null;
}

// return the user data from the session storage
export const getUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    else return null;
}

export const getPassword = () => {
    return localStorage.getItem('password') || null;
}

export const getDecryptedKey = () => {
    return localStorage.getItem('decryptedKey') || null;
}

export const getIV = () => {
    return localStorage.getItem('iv') || null;
}

export const getSalt = () => {
    return localStorage.getItem('salt') || null;
}

export const getPeerGroupSession = () => {
    return localStorage.getItem('peerGroupId') || null;
}

export const getRegionSession = () => {
    return localStorage.getItem('regionId') || null;
}

export const getLevel4 = () => {
    return localStorage.getItem('fetchedLevel4') || null;
}

export const getLevel6 = () => {
    return localStorage.getItem('fetchedLevel6') || null;
}

// remove the token and user from the session storage
export const removeUserSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('password');
    localStorage.removeItem('decryptedKey');
    localStorage.removeItem('iv');
    localStorage.removeItem('salt');

    localStorage.removeItem('fetchedLevel4');
    localStorage.removeItem('fetchedLevel4SIC');
    localStorage.removeItem('fetchedLevel6');
    localStorage.removeItem('fetchedLevel6SIC');
    localStorage.removeItem('peerGroupId');
    localStorage.removeItem('regionId');
    localStorage.removeItem('regionName');
    localStorage.removeItem('userIsLoggedIn');
    localStorage.removeItem('userSubscription');
    localStorage.clear()
    // Local storage
    // localStorage.removeItem("regions");
    // localStorage.removeItem("top3Regions");
    // localStorage.removeItem("quickLinks");
}
